import { hasProperty } from 'constants/routesLimited.ts'
import type { RouteRecordRaw } from 'vue-router'
import type { HideObject } from 'plugins/router/types.ts'
import { castRouteIds } from 'plugins/router/routes/castRouteIds.ts'

export const hideReports: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_report',
		value: false,
	},
}

const reportDialog: RouteRecordRaw = {
	component: () =>
		import('@/components/modules/PendingRequests/Reports/Report.vue'),
	name: 'reportView',
	path: '/reports/:id',
	props: castRouteIds,
	meta: {
		title: 'Meldung',
		auth: true,
	},
}

const reportCreate: RouteRecordRaw = {
	component: () => import('components/modules/Reports/CreateReport.vue'),
	meta: {
		title: 'Meldung verfassen',
		auth: true,
	},
	name: 'reportCreate',
	path: '/report/create',
	props: true,
}

export { reportDialog, reportCreate }
